import {
  faBuilding,
  faIdCard,
  faRoad,
  faMapMarkedAlt,
  faCity,
  faFlag,
  faPhone,
  faEnvelope,
  faUser,
  faMapPin,
  faLayerGroup,
  faMobileAlt,
  faPhoneAlt,
} from '@fortawesome/free-solid-svg-icons'
import createField from '../../utils/factory/createField'

export const customerFields = [
  {
    section: 'Cliente',
    fields: [
      createField({
        id: 'customer.parent_id',
        label: 'Cliente - Nivel Superior',
        type: 'text',
        placeholder: 'Informe o cliente de nível superior',
        notRequired: true,
        fullWidth: true,
        disabled: true,
      }),
      createField({
        id: 'customer.name',
        label: 'Razão Social',
        type: 'text',
        placeholder: 'Digite a razão social do cliente',
        required: true,
        icon: faUser,
      }),
      createField({
        id: 'customer.alias',
        label: 'Nome Fantasia',
        type: 'text',
        placeholder: 'Digite o nome fantasia',
        required: true,
        icon: faBuilding,
      }),
      createField({
        id: 'customer.cpf_cnpj',
        label: 'CPF/CNPJ',
        type: 'text',
        placeholder: 'Digite o CPF ou CNPJ',
        required: true,
        fullWidth: true,
        icon: faIdCard,
        mask: 'cpfCnpj',
      }),
      createField({
        id: 'customer.phone',
        label: 'Telefone',
        type: 'text',
        placeholder: 'Digite o telefone',
        required: false,
        icon: faPhoneAlt,
        mask: '(99) 99999-9999',
      }),
      createField({
        id: 'customer.email',
        label: 'E-mail',
        type: 'email',
        placeholder: 'Digite o e-mail',
        required: false,
        icon: faEnvelope,
      }),
    ],
  },
  {
    section: 'Endereço',
    fields: [
      createField({
        id: 'address.alias',
        label: 'Apelido',
        type: 'text',
        placeholder: 'Digite o apelido do endereço',
        required: true,
        icon: faMapMarkedAlt,
      }),
      createField({
        id: 'address.zip',
        label: 'CEP',
        type: 'text',
        placeholder: 'Digite o CEP',
        required: true,
        icon: faMapPin,
        mask: '99999-999',
      }),
      createField({
        id: 'address.street',
        label: 'Rua',
        type: 'text',
        placeholder: 'Digite a rua',
        required: true,
        icon: faRoad,
      }),
      createField({
        id: 'address.number',
        label: 'Número',
        type: 'text',
        placeholder: 'Digite o número',
        required: true,
        icon: faMapPin,
      }),
      createField({
        id: 'address.district',
        label: 'Bairro',
        type: 'text',
        placeholder: 'Digite o bairro',
        required: true,
        icon: faMapPin,
      }),
      createField({
        id: 'address.city',
        label: 'Cidade',
        type: 'text',
        placeholder: 'Digite a cidade',
        required: true,
        icon: faCity,
      }),
      createField({
        id: 'address.state',
        label: 'Estado',
        type: 'text',
        placeholder: 'Digite o estado',
        required: true,
        icon: faLayerGroup,
      }),
      createField({
        id: 'address.country',
        label: 'País',
        type: 'text',
        placeholder: 'Digite o país',
        required: true,
        icon: faFlag,
      }),
      createField({
        id: 'address.contact_name',
        label: 'Contato',
        type: 'text',
        placeholder: 'Digite o contato',
        required: false,
        icon: faUser,
      }),
      createField({
        id: 'address.contact_phone',
        label: 'Telefone',
        type: 'text',
        placeholder: 'Digite o telefone',
        required: false,
        icon: faPhoneAlt,
        mask: '(99) 99999-9999',
      }),
      createField({
        id: 'address.contact_email',
        label: 'E-mail do Contato',
        type: 'text',
        placeholder: 'Digite o e-mail',
        required: false,
        fullWidth: true,
        icon: faEnvelope,
      }),
    ],
  },
  {
    section: 'Localização',
    fields: [
      createField({
        id: 'location.area',
        label: 'Área',
        type: 'text',
        placeholder: 'Digite a área',
        icon: faMapMarkedAlt,
      }),
      createField({
        id: 'location.section',
        label: 'Seção',
        type: 'text',
        placeholder: 'Digite a seção',
        icon: faLayerGroup,
      }),
      createField({
        id: 'location.spot',
        label: 'Ponto',
        type: 'text',
        placeholder: 'Digite o ponto',
        icon: faMapPin,
      }),
      createField({
        id: 'location.details',
        label: 'Detalhes',
        type: 'text',
        placeholder: 'Digite os detalhes',
        icon: faMapPin,
      }),
    ],
  },
  {
    section: 'Contato',
    fields: [
      createField({
        id: 'contact.name',
        label: 'Nome',
        type: 'text',
        placeholder: 'Digite o nome do contato',
        required: false,
        icon: faUser,
      }),
      createField({
        id: 'contact.surname',
        label: 'Sobrenome',
        type: 'text',
        placeholder: 'Digite o sobrenome do contato',
        required: false,
        icon: faUser,
      }),
      createField({
        id: 'contact.role',
        label: 'Cargo',
        type: 'text',
        placeholder: 'Digite o cargo',
        required: false,
        icon: faUser,
      }),
      createField({
        id: 'contact.phone',
        label: 'Telefone',
        type: 'text',
        placeholder: 'Digite o telefone',
        required: false,
        icon: faPhone,
        mask: '(99) 99999-9999',
      }),
      createField({
        id: 'contact.cell',
        label: 'Celular',
        type: 'text',
        placeholder: 'Digite o número do celular',
        required: false,
        icon: faMobileAlt,
        mask: '(99) 99999-9999',
      }),
      createField({
        id: 'contact.email',
        label: 'E-mail',
        type: 'email',
        placeholder: 'Digite o e-mail',
        required: true,
        icon: faEnvelope,
      }),
    ],
  },
]

export const editCustomerFields = [
  {
    section: 'Cliente',
    fields: [
      createField({
        id: 'customer.alias',
        label: 'Nome Fantasia',
        type: 'text',
        placeholder: 'Digite o nome fantasia',
        required: true,
        icon: faBuilding,
        disabled: false,
      }),
      createField({
        id: 'customer.name',
        label: 'Razão Social',
        type: 'text',
        placeholder: 'Digite a razão social do cliente',
        required: true,
        icon: faUser,
        disabled: false,
      }),
      createField({
        id: 'customer.cpf_cnpj',
        label: 'CPF/CNPJ',
        type: 'text',
        placeholder: 'Digite o CPF ou CNPJ',
        required: true,
        fullWidth: true,
        icon: faIdCard,
        mask: 'cpfCnpj',
        disabled: false,
      }),
      // createField({
      //   id: "customer.parent_id",
      //   label: "Sub-cliente",
      //   type: "select",
      //   placeholder: "Selecione os sub-clientes",
      //   notRequired: true,
      //   fullWidth: true,
      //   icon: faBuilding,
      // }),
      createField({
        id: 'customer.phone',
        label: 'Telefone',
        type: 'text',
        placeholder: 'Digite o telefone',
        required: false,
        icon: faPhoneAlt,
        mask: '(99) 99999-9999',
      }),
      createField({
        id: 'customer.email',
        label: 'E-mail',
        type: 'email',
        placeholder: 'Digite o e-mail do cliente',
        required: true,
        icon: faEnvelope,
      }),
    ],
  },
]

export const detailsCustomerFields = [
  {
    section: 'Cliente',
    fields: [
      createField({
        id: 'customer.alias',
        label: 'Nome Fantasia',
        type: 'text',
        placeholder: 'Digite o nome fantasia',
        required: true,
        icon: faBuilding,
        disabled: true,
      }),
      createField({
        id: 'customer.name',
        label: 'Razão Social',
        type: 'text',
        placeholder: 'Digite a razão social do cliente',
        required: false,
        icon: faUser,
        disabled: true,
      }),
      createField({
        id: 'customer.cpf_cnpj',
        label: 'CPF/CNPJ',
        type: 'text',
        placeholder: 'Digite o CPF ou CNPJ',
        required: true,
        fullWidth: true,
        icon: faIdCard,
        mask: 'cpfCnpj',
        disabled: true,
      }),
      createField({
        id: 'customer.parent_id',
        label: 'Cliente',
        type: 'select',
        placeholder: 'Selecione o cliente',
        notRequired: true,
        fullWidth: true,
        disabled: true,
      }),
      createField({
        id: 'customer.phone',
        label: 'Telefone',
        type: 'text',
        placeholder: 'Digite o telefone',
        required: false,
        icon: faPhoneAlt,
        mask: '(99) 99999-9999',
        disabled: true,
      }),
      createField({
        id: 'customer.email',
        label: 'E-mail',
        type: 'email',
        placeholder: 'Digite o e-mail do cliente',
        required: false,
        icon: faEnvelope,
        disabled: true,
      }),
    ],
  },
]
